@if(loader){
<app-loader></app-loader>
}
<p-card>
    <div class="">
        <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
            <div class="flex align-items-center">
                <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" size="small"
                    (click)="CreatePOrder()" pTooltip="Create Purchase Return"></p-button>

                <div class="flex align-items-center ml-3">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"
                            class=" p-inputtext-sm" (keyup.enter)="searchPO()"
                            style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" autocomplete="one-time-code"/>

                    </span>
                    <p-button icon="pi pi-search" (onClick)="searchPO()" [ngStyle]="{ height: '35px' }" [raised]="true"
                        class="ml-2" [size]="'small'" severity="info"></p-button>
                </div>
                <p-button *ngIf="selectedPOrder && selectedPOrder.length == 1" label="Edit" class="ml-2"
                    icon="pi pi-user-edit" (click)="editPOrder()" size="small" severity="secondary"></p-button>
                <p-button *ngIf="selectedPOrder && selectedPOrder.length > 0" label="Delete" class="ml-2"
                    icon="pi pi-trash" (click)="deletePOrder()" size="small" severity="danger"></p-button>
            </div>

            <h2 class="page-title-center">Purchase Return List</h2>

            <div class="flex">
                <div class="flex align-items-center">
                    <p-button (onClick)="sendOrderEmail()" label="Send Mail" class="p-button-outlined ml-2"
                        icon="pi pi-envelope" severity="info" size="small"></p-button>
                    <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true" class="ml-2"
                        severity="info"></p-button>
                </div>&nbsp;
            </div>
        </div>
        <p-table #dt1 [value]="result.purchaseOrderReturn" [scrollable]="true" scrollHeight="630px"
            styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm "
            [paginator]="true" [rows]="10" (onPage)="loadPOrder($event)" [(selection)]="selectedPOrder"
            [globalFilterFields]="['purchaseOrderNumber','vendor.vendorCode','vendor.vendorName','warehouse.warehouseCode','poTotal','requestedDate','purchaseOrder_Status']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10 ,15, 20]">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Purchase Return</th>
                    <th>Return Date</th>
                    <th>Vendor Name</th> 
                    <th>{{unitLabel}} Name</th> 
                    <th>Total Amount</th>
                    <th>Status   </th>
                    <th>Created By</th>
                    <th>Print</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-purchaseOrder>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="purchaseOrder"></p-tableCheckbox>
                    </td>
                    <td class="text-blue-500 underline" style="cursor: pointer;"
                        (click)="editPOrder(purchaseOrder.returnPurchaseOrderId)">
                        {{purchaseOrder.receiptNumber}}
                    </td>
                    <td>{{purchaseOrder.returnDate | date: 'dd/MM/yyyy' }}</td>
                    <td>{{purchaseOrder.vendor.vendorName}}</td>
                    <td>{{purchaseOrder.warehouse.warehouseName}}</td>
                    <td><span>₹ {{ purchaseOrder.poTotal.toLocaleString('en-IN',{
                            minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span></td>
                    <td [ngStyle]="{
                        'color': purchaseOrder.purchaseOrder_Status === 'Closed' ? '#0fdf00' :
                                 purchaseOrder.purchaseOrder_Status === 'Process' ? '#fa8202' :
                                 (purchaseOrder.purchaseOrder_Status === 'Rejected PR' || purchaseOrder.purchaseOrder_Status === 'Rejected PO')? 'red' :
                                 'blue'
                      }">{{purchaseOrder.purchaseOrder_Status}}</td>
                    <td>{{purchaseOrder.createdBy}}</td>
                    <td><span class="pi pi-print" style="color: rgb(0 35 255); cursor: pointer;"
                            (click)="showReport(purchaseOrder)"></span></td>

                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="12">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
